import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { Button, Modal } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';

import './ScopeModal.styles.scss';

type ScopeModalProps = {
  className?: string;
  onSubmit: (values?: any) => void;
} & ModalProps;

const ScopeModal: React.ForwardRefRenderFunction<ModalRef, ScopeModalProps> = (
  props,
  ref,
) => {
  const { className, children, onSubmit, ...rest } = props;

  const classes = classNames('scope-modal', className);

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('securityScope')}
      {...rest}
    >
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            {children}

            <div className="actions">
              <Button variant="link" onClick={modal?.close}>
                {t('cancel')}
              </Button>

              <Button type="submit">{t('save')}</Button>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

export default forwardRef(ScopeModal);
